<template>
  <div id="tryout-group">
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>Paket Mata Pelajaran</li>
      <li class="active">List Paket Mata Pelajaran</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Daftar Paket Mata Pelajaran</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <div class="btn-group pull-right">
              <button type="button" class="btn btn-success btn-xs" @click="createVideo()"><span class="fa fa-plus"></span> Tambah Paket</button>
            </div>
            <h4 class="panel-title">Paket Mata Pelajaran</h4>
          </div>
          <div class="panel-body">
            <app-datatable :items="packageList" :has-action="true" :has-publish="true" :has-edit="true" :headers="headers"
              v-on:selected="selectedRow = $event" v-on:dblClicked="showBab($event)" v-on:editNewTab="editPackage($event)"
              v-on:deleted="deletePackage($event)" v-on:publishing="publish($event)" v-on:unpublishing="unpublish($event)"></app-datatable>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>
<script>
import DataTable from '@/components/plugins/DataTable'
import bimbelService from '@/services/bimbel.js'
import AppSpinner from '@/components/plugins/Spinner'
import Moment from 'moment'

export default
{
  name: 'tryout-group',
  components: {
    'app-datatable': DataTable,
    'app-spinner': AppSpinner,
  },
  data: function() {
    return {
      packageList: [],
      selectedRow: null,
      isLoading: false,
      headers: ['Nama', 'Jenjang', 'Kelas', 'Kurikulum', 'Status', 'Mata Pelajaran', 'Semester'],
      showModal: false
    }
  },
  mounted: function() {
    this.fetchData()
    this.$store.commit('video_reset')
  },
  methods: {
    fetchData: function() {
      this.packageList = []
      var context = this
      bimbelService.getListPackage( (result) => {
        if (result.success) {
          result.data.forEach(function (packRow) {
            var row = {
              id: packRow.id,
              data: [
                packRow.name,
                packRow.jenjang,
                packRow.grade,
                packRow.curriculum,
                packRow.status,
                packRow.mapel_name,
                packRow.semester
              ],
              status: packRow.status
            }
            // context.pagination.totalPages = group.page
            context.packageList.push(row)
          })
        }
      })
    },
    createVideo: function() {
      this.$router.push({path: '/paket-mapel/form'})
    },
    editPackage: function(item) {
      this.$router.push({path: '/paket-mapel/form/'+item.id})
    },
    showBab: function(item){
      this.$router.push({path: '/paket-mapel/'+item.id})
    },
    deletePackage: function(item) {
      var context = this
      var itemid = item.id
      var confirmed = window.confirm("Apakah anda yakin akan menghapus group ini?")
      if (confirmed) {
        // this.isLoading = true
        bimbelService.deleteMapelPackage(itemid, (result) => {
          if (result.success) {
            // context.isLoading = false
            context.fetchData()
            setTimeout(function() {
              alert('Data Terhapus')
            }, 1200)
          }
        })
      }
    },
    publish: function(item){
      var context = this
      var itemid = item.id
      var confirmed = window.confirm("Apakah anda yakin akan publish data ini?")
      if (confirmed) {
        // this.isLoading = true
        bimbelService.publishMapel(itemid, (result) => {
          if (result.success) {
            // context.isLoading = false
            alert('Data telah dipublish')
            context.fetchData()
          }
        })
      }
    },
    unpublish: function(item){
      var context = this
      var itemid = item.id
      var confirmed = window.confirm("Apakah anda yakin akan unpublish data ini?")
      if (confirmed) {
        // this.isLoading = true
        bimbelService.publishMapel(itemid, (result) => {
          if (result.success) {
            // context.isLoading = false
            alert('Data telah di unpublish')
            context.fetchData()
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ListPaketMapel.vue?56caddfa